export default "__VITE_ASSET__5194613a__"